import React from "react";

export const SellerContext = React.createContext();